import React, { useRef, useEffect, useState } from 'react'
import { Animated, View, Text, StyleSheet } from 'react-native'

export const ToolTipView = ({ children, tooltip = null }) => {
    const [showTooltip, setShowTooltip] = useState(true)
    const fade = useRef(new Animated.Value(0)).current

    useEffect(() => {
        Animated.timing(fade, {
            toValue: 1,
            duration: 300,
            useNativeDriver: true,
        }).start()

        const timer = setTimeout(() => {
            Animated.timing(fade, {
                toValue: 0,
                duration: 300,
                useNativeDriver: true,
            }).start(() => setShowTooltip(false))
        }, 2000)

        return () => clearTimeout(timer)
    }, [fade])

    if (!showTooltip || !tooltip) return <>{children}</>

    return (
        <View style={styles.anchorContainer}>
            <Animated.View style={[styles.tooltipWrapper, { opacity: fade }]}>
                {/* Burbuja del Tooltip */}
                <View style={styles.bubble}>
                    <Text style={styles.text} numberOfLines={1}>
                        {tooltip}
                    </Text>
                </View>

                {/* Flecha posicionada a la derecha para que coincida con el icono */}
                <View style={styles.arrow} />
            </Animated.View>

            {children}
        </View>
    )
}

const styles = StyleSheet.create({
    anchorContainer: {
        position: 'relative',
        // Quitamos el alignItems: center para manejarlo nosotros
    },
    tooltipWrapper: {
        position: 'absolute',
        bottom: '70%',
        marginBottom: 8,
        zIndex: 999,
        // IMPORTANTE: En lugar de centrar, lo pegamos a la derecha
        // del contenedor del icono
        right: 0,
        alignItems: 'flex-end', // Alinea la burbuja y la flecha a la derecha
    },
    bubble: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        paddingVertical: 8,
        paddingHorizontal: 8,
        borderRadius: 8,
        // Evita que el tooltip sea demasiado ancho o pequeño
        minWidth: 100,
        maxWidth: 200,
    },
    text: {
        color: 'white',
        fontSize: 12,
        fontWeight: '400',
        textAlign: 'center',
    },
    arrow: {
        width: 0,
        height: 0,
        borderLeftWidth: 6,
        borderRightWidth: 6,
        borderTopWidth: 6,
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent',
        borderTopColor: 'rgba(0, 0, 0, 0.9)',
        marginTop: -1,
        // Alineamos la flecha con el centro del icono (asumiendo que el icono mide unos 24-30px)
        marginRight: 10,
    },
})
